import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import data from './Speakers.json';
import Grid from '@material-ui/core/Grid';

const classes=  {
    h1 : {
        margin:'left',
        align:'left',
        justify:'left',
        color: '#009688',
        paddingTop:30,
        width:'100%',
        marginBottom:40,
        
        borderTop: 'solid 0.02em',
        },
    h2 : {
    margin:'auto',
    align:'left',
    justify:'left',
    color: '#009688',
    paddingBottom:30,
    borderBottom: 'solid 0.04em',
    width:'100%',
    marginBottom:60,
    fontStyle:'italic'
    },
    p: {
       color: '#4A4A4A',
       fontSize: 16,
       marginBottom: 50,
       fontsize:18
    }
}

const speakers=data.speakers.sort((a,b)=> a.lastname.localeCompare(b.lastname));


export class Speakers extends Component {
    render() {
        return ( 
            <div align="left" style={{margin:'7%'}}>
                <Typography variant="h3" style={classes.h1}>
                   Invited Speakers 
                </Typography>
                <Typography  style={classes.p}>
        
         </Typography>
                <Grid container spacing={4} style={{lineHeight: 2, align:'center'}}>
                
     <Grid item>
     
                <Typography  style={classes.p}>
                   {speakers.slice(0,12).map(speaker=> <span key={speaker.lastname}>{speaker.firstname}  {speaker.lastname} ({speaker.institute})<br/> </span>)}
                </Typography>
                </Grid>
                <Grid item>
                <Typography  style={classes.p}>
                   {speakers.slice(12,25).map(speaker=> <span key={speaker.lastname}>{speaker.firstname}  {speaker.lastname} ({speaker.institute})<br/> </span>)}
                </Typography>
                </Grid>
                
                </Grid>
              

              
            </div>
            )
        }
    }


export default Speakers;